console.log("📌 GTM Add-to-Cart Script Loaded");

document.addEventListener("DOMContentLoaded", function() {
  // ✅ Add to Cart (works for both normal submit & AJAX themes)
  document.addEventListener("click", function(e) {
    const btn = e.target.closest('form[data-type="add-to-cart-form"] button[type="submit"]');
    if (!btn) return;

    const form = btn.closest("form");
    if (!form) return;

    const payloadInput = form.querySelector(".gtmPayload");
    if (!payloadInput) {
      console.warn("⚠️ No GTM payload found in form");
      return;
    }

    try {
      const data = JSON.parse(payloadInput.value);
      data.event = "add_to_cart"; // enforce correct event name

      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null }); // reset previous ecommerce object
        window.dataLayer.push(data);
        console.log("✅ GTM Add-to-Cart Event Fired:", data);
      }
    } catch (err) {
      console.error("❌ GTM add_to_cart payload parse error", err);
    }
  });

  // ✅ Remove from Cart (cart page or mini cart)
  document.addEventListener("click", function(e) {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;

    const formRow = removeBtn.closest("[data-cart-item]");
    if (!formRow) return;

    const payloadInput = formRow.querySelector(".gtmPayload");
    if (!payloadInput) {
      console.warn("⚠️ No GTM payload found for remove item");
      return;
    }

    try {
      const data = JSON.parse(payloadInput.value);
      data.event = "remove_from_cart";

      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(data);
        console.log("🗑️ GTM Remove-from-Cart Event Fired:", data);
      }
    } catch (err) {
      console.error("❌ GTM remove_from_cart payload parse error", err);
    }
  });
});
